import { Autocomplete, TextField } from "@mui/material";
import { MultichoiceFormFieldProps } from "../types";
import React from "react";

const MultichoiceFormField = React.memo(({ name, label, disabled = false, required, props, renderInputProps, generateRenderInputProps }: MultichoiceFormFieldProps) => {
  return (
    <Autocomplete
      fullWidth
      id={name}
      disabled={disabled}
      renderInput={(params) => (
        <TextField {...params} name={name} label={label} required={required} {...renderInputProps} {...(generateRenderInputProps ? generateRenderInputProps(params) : {})} />
      )}
      isOptionEqualToValue={props?.isOptionEqualToValue || undefined}
      {...props}
    />
  );
});

export default MultichoiceFormField;
